module.exports = __webpack_public_path__ + "static/media/icon4.b1821247.svg";